import React from 'react'

import { Reply } from '@material-ui/icons'

export default (props) => <Reply {...props} style={{ transform: 'scaleX(-1)' }} />
